import {
  SET_VALUE_COTACAO,
  SET_PAISES_COTACAO,
  SET_RESULT_COTACAO,
  SET_FORM_COTACAO,
  SET_LOADING_COTACAO,
  SET_LIMITES_PAIS_MOEDAS,
  SET_INITIAL_STATE,
  SET_ULT_ALT_VR
} from './types';

const initialState = {
  paises: [],
  paisMoedas: [], 
  form: {
    valorEnvia: "1000.00",
    valorRecebe: null, 
    paisEnvia: {
      IdMoeda: "BRL",
      NomeMoeda: "Real",
      IdPais: "BRA",
      NomePais: "REAL",
    },
    paisRecebe: {
      IdMoeda: "USD",
      NomeMoeda: "Dolar",
      IdPais: "USA",
      NomePais: "ESTADOS UNIDOS",
      TaxaCambio: "",
      Id: 0
    },
  },
  result: {
    prazoChegada: 2,
    valorEnvia: "",
    valorRecebe: "",  
    valorIof: "",
    taxaCambio: "",
    valorTaxaVET: ""
  },  
  motivos: null,
  tarifa: null,
  limites: null,
  taxasCambio: null,
  valorMinDolar: "10.00",
  valorMaxDolar: "10,000.00",
  textWarning: null,
  textError: null,
  loading: true,
  ultAltValorRecebe: false
}

export default function cotacaoReducer(state = initialState, action) {
  switch (action.type) {
    case SET_VALUE_COTACAO:
      return {
        ...state,
        [action.payload.name]: action.payload.value,
      }
    case SET_PAISES_COTACAO:
      return {
        ...state,
        paises: action.payload
      }
    case SET_RESULT_COTACAO:
      return {
        ...state,
        result: {
          prazoChegada: action.payload.PrevisaoChegada,
          valorEnvia: action.payload.ValorEnviadoMoedaBase,
          valorRecebe: action.payload.ValorReceberLiquidoDestino,
          valorIof: action.payload.ValorIof,
          taxaCambio: action.payload.TaxaCambio,
          valorTaxaVET: action.payload.ValorTaxaVET
        },
        textWarning: null,
        textError: null       
      }
    case SET_FORM_COTACAO:
      return {
        ...state,
        form: {
          ...state.form,
          [action.payload.name]: action.payload.value,
          textWarning: null
        }        
      }
    case SET_LOADING_COTACAO:
      return {
        ...state,
        loading: action.payload       
      }
    case SET_LIMITES_PAIS_MOEDAS:
      return {
        ...state,
        paisMoedas: action.payload.arrayPaisMoedas,
        limites: action.payload.limites,
        tarifa: action.payload.tarifa,
        taxasCambio: action.payload.taxasCambio,
        motivos: action.payload.motivos,
      }
    case SET_ULT_ALT_VR:
      return {
        ...state,
        ultAltValorRecebe: action.payload
      }
    case SET_INITIAL_STATE:
      return initialState 
    default:
      return state
  }
}